module.exports = __webpack_public_path__ + "img/石林2_1.8d6188db.jpg";